import React from 'react';
import PropTypes from 'prop-types';
import { List, Item } from './styles';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useTranslation } from 'react-i18next';

const propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  active: PropTypes.number.isRequired
};


const Breadcrumbs = ({ items, active }) => {
  let movieId = sessionStorage.getItem("movieCinemaId");
  const history = useHistory();
  const [t] = useTranslation();
  const handlePrevious = (data, index) => {
    if (movieId && data?.length === 5) {
      if ((data[index] === 'Seats' && data[index] !== 'Snacks and Drinks') || data[index] === 'Sitzplätze') {
        history.replace(`/purchase/wizard/${movieId}/tickets`)
      }
      else if ((data[index] === 'Snacks and Drinks' && data[index] !== 'Checkout')) {
        history.replace(`/purchase/wizard/${movieId}/seats`)
      }
      else if (data[index] === 'Checkout' || data[index] === 'Zahlungspflichtig bestellen') {
        history.replace(`/purchase/wizard/${movieId}/snacks`)
      }
    }
    else if (movieId && data?.length === 4) {
      if (data[index] === 'Seats' || data[index] === 'Sitzplätze') {
        history.replace(`/purchase/wizard/${movieId}/tickets`)
      }
      else if (data[index] === 'Checkout' || data[index] === 'Zahlungspflichtig bestellen') {
        history.replace(`/purchase/wizard/${movieId}/seats`)
      }
    }
  }

  return (
    <List as="ul"
    >
      {items.map((item, i) => (
        <Item key={item} as="li" isActive={active === i}>
          <span className="_with-chevron"
            style={{ cursor: (movieId && items[active - 1] === item) ? 'pointer' : 'default' }}
            onClick={(movieId && items[active - 1] === item) ? () => handlePrevious(items, active) : undefined}
          >
            {item}
          </span>
        </Item>
      ))
      }
    </List>)
};

Breadcrumbs.propTypes = propTypes;
export default Breadcrumbs;